import { useEffect, useState } from 'react';
import { Container, VStack, Box, Spinner, Alert, AlertIcon, Button, HStack, Badge, Text } from '@chakra-ui/react';
import DOMPurify from 'dompurify';
import { api } from '../lib/api';
import { haptic } from '../telegram';

export default function RandomFlashcard() {
  const [card, setCard] = useState<any>(null);
  const [flipped, setFlipped] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchOne = async () => {
    setLoading(true); setFlipped(false); setError(null);
    try { setCard(await api.randomFlashcard()); haptic('select'); }
    catch (e: any) {
      haptic('error');
      if (e?.status === 429) setError('Günlük flashcard limitin doldu.');
      else setError('Flashcard çekilemedi.');
    } finally { setLoading(false); }
  };
  useEffect(() => { fetchOne(); }, []);

  if (loading) return <VStack p={12}><Spinner size="lg" color="accent" /></VStack>;
  if (error) return (
    <Container maxW="md" py={6}>
      <Alert status="warning" borderRadius="md"><AlertIcon />{error}</Alert>
      <Button mt={4} onClick={fetchOne}>Tekrar dene</Button>
    </Container>
  );
  if (!card) return null;

  return (
    <Container maxW="md" py={4}>
      <VStack spacing={4} align="stretch">
        {card.topic && <HStack><Badge colorScheme="purple">{card.topic.name}</Badge></HStack>}
        <Box
          minH="280px" p={6} borderRadius="lg"
          bg={flipped ? 'flashcardBackGradient' : 'flashcardFrontGradient'}
          color="white"
          display="flex" alignItems="center" justifyContent="center"
          cursor="pointer"
          onClick={() => { haptic('select'); setFlipped((v) => !v); }}
          fontSize="lg" fontWeight="medium"
          textAlign="center"
        >
          <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(flipped ? card.backText : card.frontText) }} />
        </Box>
        <HStack>
          <Button flex="1" onClick={() => { haptic('select'); setFlipped((v) => !v); }}>
            {flipped ? 'Ön yüze' : 'Cevabı göster'}
          </Button>
          <Button flex="1" colorScheme="brand" onClick={fetchOne}>Yeni kart</Button>
        </HStack>
      </VStack>
    </Container>
  );
}
